<template>
  <v-form v-model="valid">
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="Nome Prodotto"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="price"
            type="number"
            label="Prezzo"
            required
          ></v-text-field>
          <v-row align="center">
            <v-checkbox
              v-model="discount"
              hide-details
              class="shrink mr-2 mt-0"
            >
            </v-checkbox>
            <v-text-field
              v-model="sales_price"
              :disabled="!discount"
              label="Prezzo scontato"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col>
          <v-select
            :items="sortedBrands"
            label="Marca"
            item-text="name"
            item-value="name"
            v-model="brand"
          >
            <template v-slot:append-item>
              <v-divider class="mb-2"></v-divider>
              <v-row
                no-gutters
                align="center"
                justify="center"
                style="padding: 5px"
              >
                <v-col cols="1">
                  <v-icon>mdi-plus</v-icon>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="newBrand"
                    solo
                    dense
                    hide-details="auto"
                    label="Marca"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" class="d-flex justify-center">
                  <v-btn small style="margin: 0 auto" @click="addBrand"
                    >Salva</v-btn
                  >
                </v-col>
              </v-row>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12">
          <v-textarea
            v-model="description"
            name="Descrizione"
            label="Descrizione"
            required
          ></v-textarea>
        </v-col>
        <v-col cols="6">
          <v-select
            :items="categories"
            label="Categoria"
            item-text="display"
            item-value="value"
            v-model="category"
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            :items="sizeslist"
            label="Taglia"
            item-text="display"
            item-value="value"
            v-model="sizes"
          ></v-select>
        </v-col>
        <v-col>
          <v-btn @click="editav = true" class="buttonwidth"
            >Modifica Disponibilità</v-btn
          >
          <v-dialog v-model="editav">
            <v-card>
              <AvailabilityEdit v-model="measures" @input="closeAv" />
            </v-card>
          </v-dialog>
        </v-col>
        <v-col>
          <v-btn
            v-if="!imagesel && !image"
            @click="imagesel = true"
            class="buttonwidth"
          >
            Aggiungi Immagine
          </v-btn>
          <div v-if="!imagesel && image">
            <v-btn @click="imagesel = true" class="buttonwidth">
              Cambia Immagine
            </v-btn>
          </div>
          <v-dialog v-model="imagesel">
            <v-card>
              <MediaPicker
                nullselection
                :oldselection="image"
                @selection="select"
              />
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="12">
          <v-btn
            :disabled="!valid"
            @click="send"
            color="green"
            dark
            style="width: 100%;"
          >
            Salva
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import MediaPicker from "../components/Media/MediaPicker";
import AvailabilityEdit from "../components/AvailabilityEdit";

export default {
  name: "AddShoe",
  components: { MediaPicker, AvailabilityEdit },
  data: () => {
    return {
      categories: [
        { display: "Scarpe da Calcio", value: "calcio" },
        { display: "Scarpe da Calcetto", value: "calcetto" },
        { display: "Outlet", value: "outlet" }
      ],
      sizeslist: [
        { display: "Bambino", value: "child" },
        { display: "Uomo", value: "man" }
      ],
      brands: [],
      newBrand: "",
      brand: "",
      sizes: "",
      category: "",
      valid: false,
      name: "",
      image: "",
      imagesel: false,
      nameRules: [v => !!v || "Nome è richiesto"],
      price: 0,
      email: "",
      description: "",
      measures: [],
      editav: false,
      editing: false,
      discount: false,
      sales_price: null
    };
  },
  methods: {
    parseNumber(num) {
      return Number.parseFloat(`${num}`.replace(',','.').replace(' ',''));
    },
    select: function(sel) {
      this.image = sel;
      this.imagesel = false;
    },
    editAvailability: function() {
      this.editav = true;
    },
    addBrand: async function() {
      if (this.newBrand !== "") {
        const response = await fetch(`${process.env.VUE_APP_BACKEND}/brands/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user-token")}`
          },
          body: JSON.stringify({ name: this.newBrand })
        });
        this.brands.push(await response.json());
      }
    },
    closeAv: function(measures) {
      console.log("Save measures");
      this.measures = measures;
      this.editav = false;
    },
    send: async function() {
      const body = {
        name: this.name,
        price: this.parseNumber(this.price),
        description: this.description,
        category: this.category,
        sizes: this.sizes,
        image: this.image,
        measures: this.measures,
        brand: this.brand,
        discount: this.discount
      };

      if (this.discount) {
        body["sales_price"] = this.parseNumber(this.sales_price);
      }

      if (this.valid && !this.editing) {
        const response = await fetch(`${process.env.VUE_APP_BACKEND}/shoe/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user-token")}`
          },
          body: JSON.stringify(body)
        });

        console.log(response);
        if (response.ok) this.$router.push("/");
      } else if (this.valid && this.editing) {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND}/shoe/${this.$route.params.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("user-token")}`
            },
            body: JSON.stringify(body)
          }
        );

        console.log(response);
        if (response.ok) this.$router.push("/");
      }
    }
  },
  computed: {
    sortedBrands: function() {
      let newbrand = [...this.brands];
      return newbrand.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  },
  mounted: async function() {
    let brands = await fetch(`${process.env.VUE_APP_BACKEND}/brands/`);
    this.brands = await brands.json();
    console.log(brands);

    if (this.$route.params.id) {
      console.log(this.$route.params.id);
      this.editing = true;

      let res = await fetch(
        `${process.env.VUE_APP_BACKEND}/shoe/${this.$route.params.id}`
      );
      res = await res.json();

      this.sizes = res.sizes;
      this.category = res.category;
      this.name = res.name;
      this.image = res.image;
      this.price = res.price;
      this.description = res.description;
      this.measures = res.measures;
      this.discount = res.discount;
      if (res.brand) {
        this.brand = res.brand;
      }
      if (res.discount) {
        this.sales_price = res.sales_price;
      }
    }
  }
};
</script>

<style scoped>
.buttonwidth {
  width: 100%;
}
</style>
